import { render, staticRenderFns } from "./extendServices.vue?vue&type=template&id=6608de7e&scoped=true&"
import script from "./extendServices.vue?vue&type=script&lang=ts&"
export * from "./extendServices.vue?vue&type=script&lang=ts&"
import style0 from "./extendServices.vue?vue&type=style&index=0&id=6608de7e&scoped=true&lang=less&"
import style1 from "./extendServices.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6608de7e",
  null
  
)

export default component.exports